import React from 'react';
export var Section = function (_a) {
    var children = _a.children;
    return (React.createElement("section", { className: "flex flex-col m-0 box-border w-full md:flex-col lg:flex-row" }, children));
};
